import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
// import { AdminComponent } from '../users/admin/admin.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserHomeComponent } from './user-home/user-home.component';
import { TestProjectComponent } from './test-project/test-project.component';
import { ViewbuildigsTestComponent } from './buildings/viewbuildigs-test/viewbuildigs-test.component';
import { FlatPropertiesTestComponent } from './buildings/flat-properties-test/flat-properties-test.component';
import { ViewsFromFloorsComponent } from './buildings/views-from-floors/views-from-floors.component';
import { TestViewConstructionPointComponent } from './test-view-construction-point/test-view-construction-point.component';
import { NShowGalleryComponent } from './n-show-gallery/n-show-gallery.component';
import { NPageWithLinkComponent } from './n-page-with-link/n-page-with-link.component';
import { NCompanyPageComponent } from './n-company-page/n-company-page.component';
import { NMapComponent } from './n-map/n-map.component';
import { OfferComponent } from './offers-components/offer/offer.component';
import { ProjectLightComponent } from './project-light/project-light.component';
import { NearbyOnMapComponent } from './nearby-on-map/nearby-on-map.component';
import { AboutProjectComponent } from './about-project/about-project.component';
import { ProjectStatusComponent } from './project-status/project-status.component';
import { MaterialsFromClientComponent } from './materials-from-client/materials-from-client.component';
import { PriceCalculatorComponent } from './price-calculator/price-calculator.component';
import { CalculatorOfferComponent } from './calculator-offer/calculator-offer.component';
import { AuthCallbackComponent } from '../_core/auth-callback/auth-callback.component';
import { GoogleMapComponentGPT } from './google-map-component-gpt/google-map-gpt.component';
import { VoiceNavigationComponent } from './voice-navigation/voice-navigation.component';
import { languageGuard } from '../_core/_guard/language.guard';
import { PriceCalculatorHousingComponent } from './price-calculator-housing/price-calculator-housing.component';
import { OfferListComponent } from './offer-list/offer-list.component';
import { AllprojmapComponent } from './allprojmap/allprojmap.component';



const routes: Routes = [{
  path: '', component: UserHomeComponent,
  children: [
    { path: '',
  redirectTo: 'user', pathMatch: 'full'},


    { path: 'company/u/spirikal-map', component: AllprojmapComponent  },
    { path: 'company/u/:id/map', component: NMapComponent  },
    { path: 'company/:id/map', component: NMapComponent  },
    { path: 'company/:id', component: NCompanyPageComponent  },
    { path: 'company/n/:id', component: NCompanyPageComponent  },
    { path: 'company/u/:id', component: NCompanyPageComponent  },
    { path: 'company/u/:id', component: NCompanyPageComponent  },
    
    { path: 'company/n/:id/:idp/offers/:offerUid', component: OfferComponent  },
    { path: 'company/u/:id/:idp/offers/:offerUid', component: OfferComponent },
    // { path: 'company/u/:id/:idp/nearbyProject', component: NearbyOnMapComponent  },
    { path: 'company/u/:id/:idp/nearbyProject', component: GoogleMapComponentGPT },

    
    // { path: 'company/u/:id/:idp/nearbyProject', component: GoogleMapComponentGPT  },
    { path: 'company/u/:id/:idp/about', component: AboutProjectComponent  },
    { path: 'company/u/:id/:idp/projstatus', component: ProjectStatusComponent  },
    { path: 'company/u/:id/:idp/materials', component: MaterialsFromClientComponent  },
   
    
    // { path: 'company/:id/:idp', component: AdminComponent },
    // {path: 'company/:id/:idp/test', component: TestProjectComponent},
    // {
    //   path: 'company/:id/:idp/test', component: TestProjectComponent,
    //   children: [
    //     {
    //       path: 'company/:id/:idp/test/building/:buid', component: ViewbuildigsTestComponent,
    //       children: [
    //         { path: 'company/:id/:idp/test/building/:buid/:flatId', component: FlatPropertiesTestComponent }
    //       ]
    //     }
    //   ]
    // },
    // {path: 'company/:id/:idp/test', component: TestProjectComponent},
    // { path: 'company/:id/:idp/test/gallery/:section', component: NShowGalleryComponent },
    // { path: 'company/:id/:idp/test/galleryD/:section/:galleryId', component: NPageWithLinkComponent },

    // { path: 'company/:id/:idp/test/constructionPoint', component: TestViewConstructionPointComponent },
    // { path: 'company/:id/:idp/test/viewFloors/:viewFromFloor', component: ViewsFromFloorsComponent },
    // { path: 'company/:id/:idp/test/building/:buid', component: ViewbuildigsTestComponent },
    // { path: 'company/:id/:idp/test/building/:buid/:flatId', component: FlatPropertiesTestComponent },

    {path: 'company/:id/:idp', component: TestProjectComponent },
    {path: 'u/:compName/:projectName', component: TestProjectComponent },
    {path: 'company/n/:id/:idp', component: TestProjectComponent },
    {path: 'company/u/:id/:idp', component: TestProjectComponent },
    {path: 'sehel/u/:sehelProjId/:seheluser', component: ProjectLightComponent },
    {path: 'company/u/:id/:idp/seheluser/:seheluser', component: ProjectLightComponent },
    {path: 'company/u/:id/:idp/seheluser/:seheluser/building/:buid', component: ProjectLightComponent },
    {path: 'company/u/:id/:idp/seheluser/:seheluser/building/:buid/:flatId', component: ProjectLightComponent },
    { path: 'company/u/:id/:idp/seheluser/:seheluser/viewFloors/:floorNumber/:viewFromFloor', component: ViewsFromFloorsComponent  },
    { path: 'company/u/:id/:idp/seheluser/:seheluser/gallery/:section', component: NShowGalleryComponent  },
    { path: 'company/u/:id/:idp/seheluser/:seheluser/galleryD/:section/:galleryId', component: NPageWithLinkComponent  },
    
    // {path: 'company/u/:id/:idp/seheluser/:user', component: ProjectLightComponent},

    { path: 'company/:id/:idp/gallery/:section', component: NShowGalleryComponent  },
    { path: 'company/:id/:idp/galleryD/:section/:galleryId', component: NPageWithLinkComponent  },
    { path: 'company/n/:id/:idp/gallery/:section', component: NShowGalleryComponent  },
    { path: 'company/u/:id/:idp/gallery/:section', component: NShowGalleryComponent  },
    { path: 'company/n/:id/:idp/galleryD/:section/:galleryId', component: NPageWithLinkComponent  },
    { path: 'company/u/:id/:idp/galleryD/:section/:galleryId', component: NPageWithLinkComponent  },
    { path: 'company/:id/:idp/u/constructionPoint', component: TestViewConstructionPointComponent  },
    { path: 'company/n/:id/:idp/constructionPoint', component: TestViewConstructionPointComponent  },
    { path: 'company/u/:id/:idp/constructionPoint', component: TestViewConstructionPointComponent  }, 
    { path: 'company/:id/:idp/viewFloors/:floorNumber/:viewFromFloor', component: ViewsFromFloorsComponent  },
    { path: 'company/n/:id/:idp/viewFloors/:floorNumber/:viewFromFloor', component: ViewsFromFloorsComponent  },
    { path: 'company/u/:id/:idp/viewFloors/:floorNumber/:viewFromFloor', component: ViewsFromFloorsComponent  },
    { path: 'company/:id/:idp/building/:buid', component: ViewbuildigsTestComponent  },
    { path: 'company/n/:id/:idp/building/:buid', component: TestProjectComponent  },
    { path: 'company/u/:id/:idp/building/:buid', component: TestProjectComponent  },
    { path: 'company/:id/:idp/building/:buid/:flatId', component: FlatPropertiesTestComponent  },
    { path: 'company/n/:id/:idp/building/:buid/:flatId', component: TestProjectComponent  },
    { path: 'company/u/:id/:idp/building/:buid/:flatId', component: TestProjectComponent  },
    { path: 'company/u/:id/:idp/calculator', component: PriceCalculatorComponent  },
    { path: 'company/u/:id/:idp/calculatorh', component: PriceCalculatorHousingComponent  },
    { path: 'company/u/:id/:idp/calculator-offer/:userId', component: CalculatorOfferComponent  },
    { path: 'company/u/:id/:idp/list-offer', component: OfferListComponent  },
    { path: 'company/u/:id/:idp/calculator-offer/:userId/:mapId', component: GoogleMapComponentGPT  },
    { path: 'company/u/:id/:idp/list-offer/:userId/:mapId', component: GoogleMapComponentGPT  },
    { path: 'company/u/:id/:idp/voice', component: VoiceNavigationComponent  },

    { path: 'user', component: UserProfileComponent  },

    { path: 'auth-callback', component: AuthCallbackComponent  },
  { path: '', redirectTo: '/', pathMatch: 'full' },

  ]
}
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { 
  // this.dataService.getSpecProjectSehel(this.sehelProjId).subscribe(projects => {
  //   if (projects.length <= 1) {
  //     this.projectlist = false;
  //   } else {
  //     this.projectlist = true;
  //   }
  //   let curProj = projects.filter(proj => proj.uid === this.projUid);
  //   if (curProj.length > 0) {
  //     this.companyTitle = curProj[0].companyTitle;
  //     this.projectTitle = curProj[0].title;
  //   }
  // });
}
